import { createStyleSheet } from '@shared-ui/theme'
import { rw } from '@shared-ui/theme/scale'

export const useCreateStyles = createStyleSheet((theme) => ({
  icon: {
    fontFamily: 'icomoon',
    color: theme.COLOR_ICON_PRIMARY,
    includeFontPadding: false,
    // Web/TMA: icon-font не должен выделяться синим при тапе/long-press.
    userSelect: 'none',
  },
  circle: {
    backgroundColor: theme.COLOR_BG_SURFACE,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: rw(theme.SIZE_BUTTON_BORDER_RADIUS),
    height: rw(40),
    width: rw(40),
    zIndex: 1,
  },
}))
